import FormHelperText from '@mui/material/FormHelperText'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { styled } from '@mui/material/styles'

import type { HTMLAttributes } from 'react'

export const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop: string) => prop !== 'hidden',
})<{ hidden?: boolean }>(({ hidden }) => ({
  '&.MuiFormControl-root': {
    ...(hidden && { display: 'none' }),
  },
  '.MuiInputBase-root.MuiInputBase-sizeSmall': {
    padding: '6px 14px',
  },
}))

export const StyledFormTextFieldWithEndIcon = StyledTextField

export const StyledSelect = styled(Select)<{
  SelectDisplayProps?: HTMLAttributes<HTMLDivElement> & {
    'data-testid'?: string
  }
}>(() => ({
  '.MuiSelect-selectMenu': {
    boxSizing: 'border-box',
    height: '56px',
  },
}))

export const StyledFormHelperText = FormHelperText

export const StyledAutocompleteTextfield = styled(StyledTextField)({
  '.MuiAutocomplete-inputRoot': {
    flexWrap: 'unset',
  },
})
